import Icon from '../components/Icon.vue'

Icon.register({
  'rss-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM112 416c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zM269.5 416c6.5 0 11.8-5.5 11.4-12-6-110.4-94.4-199-205-205-6.5-0.4-12 4.9-12 11.4v34.3c0 6 4.6 11.1 10.6 11.4 79.9 5.2 143.9 69.1 149.1 149.1 0.4 6 5.4 10.6 11.4 10.6h34.3zM372.6 416c6.5 0 11.7-5.3 11.4-11.8-6-167-140.4-302.2-308.2-308.2-6.4-0.2-11.8 5-11.8 11.4v34.3c0 6.2 4.9 11.2 11 11.4 136.6 5.6 246.2 115.2 251.8 251.8 0.3 6.2 5.3 11 11.4 11h34.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/rss-square.js
// module id = 1849
// module chunks = 0